<script>
import Chart from 'chart.js';
import { Pie, mixins } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';

const { reactiveProp } = mixins;

Chart.helpers.merge(Chart.defaults.global.legend.position = 'bottom');
Chart.defaults.global.defaultFontFamily = "'Khmer OS System'";

export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: {
    options: {
      resposive: true,
      maintainAspectRatio: false,
    },
  },
  mounted() {
    this.addPlugin(ChartDataLabels);
    this.renderChart(this.chartData, this.options);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/BarChart.vue